import { render, staticRenderFns } from "./MailDeliveryModal.vue?vue&type=template&id=6548485b&"
import script from "./MailDeliveryModal.vue?vue&type=script&lang=js&"
export * from "./MailDeliveryModal.vue?vue&type=script&lang=js&"
import style0 from "./MailDeliveryModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports